import { useState, useRef, useLayoutEffect, useEffect } from "react";
import { getDecodedHtml } from "utils/getDecodedHtml";
import { FullWidthMediaWithCardProps } from "./types/full-width-media-with-card-types";
import VideoPopup from "components/utility/video/VideoPopup";
import { isMobile } from "components/utility/page-responsive/PageResponsive";
const FullWidthMediaWithCard = ({ data }: FullWidthMediaWithCardProps) => {
	const {
		imageAlt,
		imageUrl,
		xsImageUrl,
		xsImageAlt,
		cardPosition,
		rails,
		title,
		description,
		videoUrl,
		videoPlayTime
	} = data;
	// height of rails container should be calculated from text-card Height minus text card positive top value
	const [textCardContainerHeight, setTextCardContainerHeight] = useState<number>(0);
	const textCardRef = useRef(null);
	const [isMobileScreen, setIsMobile] = useState(false);
	useEffect(() => {
		const isMobileFunc = () => {
			if (isMobile() && xsImageUrl) {
				setIsMobile(true);
			} else {
				setIsMobile(false);
			}
		};
		isMobileFunc();
		window.addEventListener("resize", isMobileFunc);

		return () => {
			window.addEventListener("resize", isMobileFunc);
		};
	});
	useLayoutEffect(() => {
		const textCard = textCardRef?.current;

		const textCardHeightObserver = new ResizeObserver((entries) => {
			entries.forEach((entry) => {
				const entryHeight = entry.borderBoxSize[0].blockSize;
				const entryTopValue = Math.abs((entry.target as HTMLElement).offsetTop);

				if (entryHeight > entryTopValue) {
					setTextCardContainerHeight(entryHeight - entryTopValue);
				} else {
					setTextCardContainerHeight(0);
				}
			});
		});

		if (textCard) {
			textCardHeightObserver.observe(textCard);
		}
		return () => {
			textCardHeightObserver.disconnect();
		};
	}, [textCardRef]);

	return (
		<>
			<div className="full-width-media">
				{!videoUrl && imageUrl ? (
					<div className="full-width-image-container">
						<img alt={imageAlt} src={isMobileScreen ? xsImageUrl : imageUrl}></img>
					</div>
				) : (
					<VideoPopup
						srcUrl={videoUrl}
						image={imageUrl}
						alt={imageAlt}
						xsImage={xsImageUrl}
						isMobile={isMobileScreen}
						xsImageAlt={xsImageAlt}
					/>
				)}
				{cardPosition ? (
					<div className={`rails-container ${rails === true ? "" : "no-rails"}`}>
						<div className="text-card-container" style={{ height: textCardContainerHeight + "px" }}>
							<div className={`text-card ${cardPosition}`} ref={textCardRef}>
								<div className="title t-heading-md">{title}</div>
								<p
									className="description t-body-xs"
									dangerouslySetInnerHTML={{ __html: getDecodedHtml(description) }}
								></p>
								{videoUrl && videoPlayTime && (
									<p className="video-duration t-label-xs-heavy">({videoPlayTime})</p>
								)}
							</div>
						</div>
					</div>
				) : null}
			</div>
		</>
	);
};

export default FullWidthMediaWithCard;
